export const pt_br = {
    search: {
    placeholder: 'Pesquisar...'
},
    typetitle : {
    type: 'Tipos'
},
    pokecardname : {
    name: 'Nome'
},
    pokecardevolutions : {
    evolutions: 'Evoluções'
},
    pokecardmoves : {
    moves: 'Movimentos'
    },
};